<template>
    <div class="education safe-distance-top">
        <div class="education_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">教育背景</div>
            <div class="determine" @click="determine">提交</div>
        </div>
        <div class="education_bottom">
            <van-field
                v-model="education"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入个人教育背景"
                show-word-limit
                ref="input"
            />
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "education",
    data() {
        return {
            education: "",
            obj: {},
            // 教育背景 6
            educationId: "",
        };
    },
    created() {
        this.educationId = this.$route.query.educationId;
    },
    mounted() {
        // 回显
        this.education = JSON.parse(sessionStorage.getItem("educationcontent"));
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        // 保存提交
        async determine() {
            if (this.education == "") {
                Toast("内容不能为空");
            } else {
                let res = await this.$apis.userServe.addOrEditExperience({
                    content: this.education,
                    id: this.educationId,
                    type: 6,
                });
                if (res.data.resultCode == 200) {
                    Toast("提交成功");
                    window.history.go(-1);
                } else {
                    Toast(res.data.resultDesc);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.education {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .education_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .education_bottom {
        width: 94%;
        margin: 12px auto;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }
}
</style>
